module.exports = __webpack_public_path__ + "static/media/portfolio_site_tape_dispenser_1.589e266d.png";